var map = {
	"./Blood Pressure disabled.svg": 602,
	"./Blood Pressure.svg": 603,
	"./Body Temp disabled.svg": 604,
	"./Body Temp.svg": 605,
	"./Check.svg": 211,
	"./Configurations.svg": 606,
	"./Countries.svg": 607,
	"./Edit.svg": 99,
	"./Ellipse.svg": 608,
	"./Expand.svg": 244,
	"./Eye-hide.svg": 348,
	"./Eye-show.svg": 349,
	"./Flag.svg": 609,
	"./Fota.svg": 610,
	"./Glucose disabled.svg": 611,
	"./Glucose.svg": 612,
	"./Hide.svg": 212,
	"./Home.svg": 613,
	"./Inbox.svg": 614,
	"./My Profile.svg": 615,
	"./Next.svg": 300,
	"./PDF.svg": 245,
	"./PathEcg.svg": 616,
	"./Patient List.svg": 617,
	"./Patient Requests.svg": 618,
	"./Patients.svg": 619,
	"./Physicians.svg": 620,
	"./Prev.svg": 301,
	"./Pulse Rate disabled.svg": 621,
	"./Pulse Rate.svg": 622,
	"./Reports.svg": 623,
	"./Respiratory Rate disabled.svg": 624,
	"./Respiratory Rate.svg": 625,
	"./Search.svg": 205,
	"./Show.svg": 213,
	"./Sort.svg": 172,
	"./SpO2 disabled.svg": 626,
	"./SpO2.svg": 627,
	"./Viewers.svg": 628,
	"./Weight disabled.svg": 629,
	"./Weight.svg": 630,
	"./af-report-icon.svg": 350,
	"./af.svg": 302,
	"./afDetected.svg": 631,
	"./afNotDetected.svg": 632,
	"./alerton.svg": 165,
	"./annotations-report-icon.svg": 351,
	"./arrow-down.svg": 166,
	"./avatar.svg": 303,
	"./bell.svg": 167,
	"./blood-pressure-report-icon.svg": 352,
	"./calories.svg": 633,
	"./checkbox.svg": 304,
	"./circle.svg": 634,
	"./clock.svg": 214,
	"./common/github.svg": 635,
	"./common/google.svg": 636,
	"./daily-report-icon.svg": 353,
	"./events-report-icon.svg": 354,
	"./generate-unique-id.svg": 305,
	"./grid-off.svg": 306,
	"./grid.svg": 307,
	"./hamburger.svg": 637,
	"./list-on.svg": 308,
	"./list.svg": 309,
	"./medcine_reminder.svg": 310,
	"./monthly-report-icon.svg": 355,
	"./no-af.svg": 311,
	"./notMeasured.svg": 638,
	"./offwrist.svg": 312,
	"./pinnedoff.svg": 313,
	"./pinnedon.svg": 215,
	"./print.svg": 347,
	"./remindmelater.svg": 314,
	"./remove-doctor.svg": 246,
	"./saturation-report-icon.svg": 356,
	"./search-circle.svg": 639,
	"./send-circle.svg": 247,
	"./sleep-apnea-report-icon.svg": 357,
	"./sleep.svg": 640,
	"./steps.svg": 641,
	"./tike.svg": 642,
	"./timefilter.svg": 358,
	"./trash.svg": 315,
	"./watchNotConnected.svg": 316
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 243;